import type { SVGProps } from "react";
import * as React from "react";

const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 15a1 1 0 1 0-2 0zM3 19H2zm1-4a1 1 0 1 0-2 0zm3.707-5.707a1 1 0 0 0-1.414 1.414zM12 15l-.707.707a1 1 0 0 0 1.414 0zm5.707-4.293a1 1 0 0 0-1.414-1.414zM13 3a1 1 0 1 0-2 0zm7 12v4h2v-4zm0 4a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 22 19zm-.293.707A1 1 0 0 1 19 20v2a3 3 0 0 0 2.121-.879zM19 20H5v2h14zM5 20a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 5 22zm-.707-.293A1 1 0 0 1 4 19H2a3 3 0 0 0 .879 2.121zM4 19v-4H2v4zm2.293-8.293 5 5 1.414-1.414-5-5zm6.414 5 5-5-1.414-1.414-5 5zM13 15V3h-2v12z"
    />
  </svg>
);
export default SvgDownload;
